export enum ModalType {
  CUSTOM = "CUSTOM",
  CONFIRM = "CONFIRM",
  SNACKBAR = "SNACKBAR",
}